import { render, staticRenderFns } from "./loginSingleOld.vue?vue&type=template&id=21a9ae00"
import script from "./loginSingleOld.vue?vue&type=script&lang=js"
export * from "./loginSingleOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports